"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createBroadcast = exports.createBroadcast = function createBroadcast(initialValue) {
  var listeners = [];
  var currentValue = initialValue;

  return {
    publish: function publish(value) {
      currentValue = value;
      listeners.forEach(function (listener) {
        return listener(currentValue);
      });
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);

      listener(currentValue);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/utils/create-broadcast.js
// module id = 133
// module chunks = 0